import React from 'react'
import {
  faCheck,
  faClose,
  faPen,
  faPlus,
  faTrash,
  faXmark,
} from '@fortawesome/free-solid-svg-icons'
import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import { del, get } from 'client/utils/api-routes.util'
import {
  ActionIconSection,
  DcBreadcrumbs,
  DcButton,
  DcFlexBox,
  DcOverlaySlider,
  PixelFactoryContext,
  PixelIcon,
  PixelModal,
  PixelPageContainer,
  PixelTable,
  PixelTableAction,
  PixelTag,
  PixelText,
  Section,
  SectionActions,
  SectionContent,
} from 'pixel-base'
import styled from 'styled-components'

import AddNewZone from './components/AddNewZone'
import { IPixelFactory } from '../../../../../decl.d'

const breadcrumbs = [
  {
    name: 'Locations',
    active: false,
  },
  {
    name: 'Zone',
    active: true,
  },
]
const Zone = () => {
  const { showPageLoader, hidePageLoader, showSuccess, showFailure } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const [zonesList, setZonesList] = React.useState<any>([])
  const [zone, setZone] = React.useState<any>({})
  const [zoneID, setZoneID] = React.useState<any>(null)
  const [showNewModal, setShowNewModal] = React.useState(false)
  const [tableLoading, setTableLoading] = React.useState(true)
  const [expandedRowId, setExpandedRowId] = React.useState(null)
  const [cities, setCities] = React.useState<any>([])
  const fetchCities = () => {
    get('/settings/options/countries/PK/cities').subscribe((res: any) => {
      setCities(
        res.response.data.map((city: any) => ({
          label: city.name,
          value: city.id,
        })),
      )
    })
  }
  React.useEffect(() => {
    if (cities.length === 0) {
      fetchCities()
    }
  }, [])
  const getSources = () => {
    setTableLoading(true)
    get('/location/zones').subscribe((res: any) => {
      const newZoneList = res.response.data?.map((zone: any) => {
        if (res.response.data) {
          return {
            ...zone,
            expandDisabled: true,
          }
        }
        return zone
      })
      setZonesList(newZoneList)
      setTableLoading(false)
    })
  }

  React.useEffect(() => {
    getSources()
  }, [])
  const columns = [
    {
      dataKey: 'zone_name',
      name: <PixelText multiLine>Zone Name</PixelText>,
      width: '15%',
      sortable: true,
      selector: (row) => (row.zone_name ? row.zone_name : '--'),
    },
    {
      dataKey: 'is_acvtive',
      name: <PixelText multiLine>Active</PixelText>,
      width: '10%',
      sortable: true,
      selector: (row) => (
        <PixelIcon
          color={row.is_active ? 'green' : 'red'}
          icon={row.is_active ? faCheck : faXmark}
        />
      ),
    },
    {
      dataKey: 'is_default',
      name: <PixelText multiLine>Default</PixelText>,
      width: '10%',
      sortable: true,
      selector: (row) => (
        <PixelIcon
          color={row.is_default ? 'green' : 'red'}
          icon={row.is_default ? faCheck : faXmark}
        />
      ),
    },
    {
      dataKey: 'is_all_cities',
      name: <PixelText>All Cities</PixelText>,
      sortable: true,
      width: '10%',
      selector: (row) => (row.is_all_cities === true ? 'Yes' : 'No'),
    },
    {
      dataKey: 'include_cities',
      name: <PixelText>Include Cities</PixelText>,
      sortable: true,
      selector: (row) => {
        return (
          <>
            {row.include_cities.length > 0 ? (
              <>
                {row.include_cities.length > 2 ? (
                  <>
                    {row.include_cities
                      .slice(0, 2)
                      .map((city: any) => `${city.name}, `)}
                    <MoreCitiesText
                      onClick={() => {
                        const ExpandZoneList = zonesList.map((zone: any) => {
                          if (zone.zone_id === row.zone_id) {
                            return {
                              ...zone,
                              expandMe: true,
                            }
                          }
                          return zone
                        })
                        setZonesList(ExpandZoneList)
                      }}
                    >{`${row.include_cities?.length - 2} More`}</MoreCitiesText>
                  </>
                ) : (
                  <>{row.include_cities?.map((city: any) => `${city.name},`)}</>
                )}
              </>
            ) : (
              '--'
            )}
          </>
        )
      },
    },
    {
      dataKey: 'exclude_cities',
      name: <PixelText>Exclude Cities</PixelText>,
      sortable: true,
      selector: (row) => {
        return (
          <>
            {row.exclude_cities.length > 0 ? (
              <>
                {row.exclude_cities.length > 2 ? (
                  <>
                    {row.exclude_cities
                      .slice(0, 2)
                      .map((city: any) => `${city.name}, `)}
                    <MoreCitiesText
                      key={row.zone_id}
                      onClick={() => {
                        const ExpandZoneList = zonesList.map((zone: any) => {
                          if (zone.zone_id === row.zone_id) {
                            return {
                              ...zone,
                              expandMe: true,
                            }
                          }
                          return zone
                        })
                        setZonesList(ExpandZoneList)
                      }}
                    >{` ${
                      row.exclude_cities?.length - 2
                    } More`}</MoreCitiesText>
                  </>
                ) : (
                  <>
                    {row.exclude_cities?.map((city: any) => `${city.name}, `)}
                  </>
                )}
              </>
            ) : (
              '--'
            )}
          </>
        )
      },
    },
    {
      dataKey: 'actions',
      name: 'Actions',
      width: '15%',
      selector: (row) => (
        <PixelIcons>
          <PixelTableAction row={row} action={actions} />
          <PixelTableAction row={row} action={deleteActions} />
        </PixelIcons>
      ),
    },
  ]

  const actions = [
    {
      title: 'Edit',
      icon: (
        <ActionIconSection>
          <PixelIcon icon={faPen} />
        </ActionIconSection>
      ),
      clickHandler: (row) => {
        setShowNewModal(true)
        setZone(row)
        setZoneID(row.zone_id)
      },
    },
  ]
  const deleteActions = [
    {
      title: 'Delete',
      disabled: (row) => row.is_default === true,
      icon: (
        <ActionIconSection>
          <PixelIcon color="red" icon={faTrash} />
        </ActionIconSection>
      ),
      clickHandler: (row) => {
        if (!row.is_default) {
          showPageLoader()
          del(`/location/zones/${row.zone_id}`).subscribe((res: any) => {
            if (res.response.data) {
              showSuccess(res.response.data)
              const newZoneList = zonesList.filter(
                (zone: any) => zone.zone_id !== row.zone_id,
              )
              setZonesList(newZoneList)
            } else {
              showFailure(res.response.error)
            }
            hidePageLoader()
          })
        } else {
          showFailure('Default zone can not be deleted')
        }
      },
    },
  ]
  const ExpandedComponent = ({ data }) => {
    React.useEffect(() => {
      setExpandedRowId(data.zone_id)
    }, [])
    return (
      <CitiesContainer>
        <Section>
          <SectionContent style={{ position: 'relative' }}>
            {data.include_cities.length > 0 && (
              <>
                <Title>Include Cities</Title>
                <CitiesList>
                  {data.include_cities.map((city: any, index) => {
                    return (
                      <>
                        <PixelTag key={index}>{city.name}</PixelTag>
                      </>
                    )
                  })}
                </CitiesList>
              </>
            )}
            {data.exclude_cities.length > 0 && (
              <>
                <Title>Exclude Cities</Title>
                <CitiesList>
                  {data.exclude_cities.map((city: any) => {
                    return (
                      <div key={city}>
                        <PixelTag>{city.name}</PixelTag>
                      </div>
                    )
                  })}
                </CitiesList>
              </>
            )}
            <CloseExpand
              onClick={() => {
                const ExpandZoneList = zonesList.map((zone: any) => {
                  if (zone.zone_id === data.zone_id) {
                    return {
                      ...zone,
                      expandMe: false,
                    }
                  }
                  return zone
                })
                setZonesList(ExpandZoneList)
              }}
            >
              <Section>
                <PixelIcon fontSize="20px" icon={faClose} />
              </Section>
            </CloseExpand>
          </SectionContent>
        </Section>
      </CitiesContainer>
    )
  }
  return (
    <>
      <DcFlexBox
        height="60px"
        fontSize="16px"
        style={{
          fontSize: '16px',
          padding: '8px 0px',
          borderBottom: '1px solid #e5e5e5',
        }}
      >
        <DcFlexBox
          justifyContent="space-between"
          alignItems="center"
          padding=".5rem 20px"
        >
          <DcBreadcrumbs fontSize="16px" data={breadcrumbs} />

          <ProfileSection />
        </DcFlexBox>
      </DcFlexBox>

      <PixelPageContainer style={{ padding: '0px' }}>
        <Section style={{ padding: '0px' }}>
          <SectionContent style={{ padding: '0px', borderRadius: '0px' }}>
            <SectionActions
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'flex-end',
                padding: ' 5px 20px',
              }}
            >
              <DcButton size="sm" onClick={() => setShowNewModal(true)}>
                <PixelIcon color="inherit" icon={faPlus} /> Add Zone
              </DcButton>
            </SectionActions>
          </SectionContent>
        </Section>
        <Section style={{ padding: '20px' }}>
          <SectionContent>
            <PixelTable
              expandableIcon={{}}
              columns={columns}
              data={zonesList}
              progressPending={tableLoading}
              expandableRows
              expandableRowsHideExpander={false}
              expandableRowsComponent={ExpandedComponent}
              expandableRowExpanded={(row) => row.expandMe}
              expandableRowDisabled={(row) => row.expandDisabled}
              onRowExpandToggled={(row) => {
                if (row === false) {
                  const ExpandZoneList = zonesList.map((zone: any) => {
                    if (zone.zone_id === expandedRowId) {
                      return {
                        ...zone,
                        expandMe: false,
                      }
                    }
                    return zone
                  })
                  setZonesList(ExpandZoneList)
                }
              }}
            />
          </SectionContent>
        </Section>
      </PixelPageContainer>

      <DcOverlaySlider
        title={'Add New Zone'}
        width="40%"
        onClose={() => {
          setShowNewModal(false)
          setZoneID(null)
        }}
        isOpen={showNewModal}
      >
        {showNewModal && (
          <SectionContent>
            <AddNewZone
              zone={zone}
              zoneID={zoneID}
              cities={cities}
              handleClose={(data, action) => {
                if (action === 'add') {
                  setZonesList([...zonesList, data])
                } else if (action === 'update') {
                  const updatedZone = zonesList.map((zone) => {
                    if (zone.zone_id === data.zone_id) {
                      return data
                    }
                    return zone
                  })
                  setZonesList(updatedZone)
                }
                setShowNewModal(false)
                setZoneID(null)
              }}
            />
          </SectionContent>
        )}
      </DcOverlaySlider>
    </>
  )
}

const Title = styled.p`
  margin: 6px 20px !important;
  padding-left: 10px;
  font-weight: 500;
`
const CitiesContainer = styled.div`
  width: 100%;
  background-color: #f2f7f8;
  padding: 15px;
  overflow: auto;
`

const MoreCitiesText = styled.div`
  font-weight: 600;
  cursor: pointer;
`
const PixelIcons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
`
const CitiesList = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: 4px;
  padding-left: 10px;
`
const CloseExpand = styled.div`
  position: absolute;
  top: 7px;
  right: 12px;
`
export default Zone
